'use client';
import { createRef } from 'react';
import Image from 'next/image';
import Link from 'next/link';

import ScrollWithCarets from 'src/components/ScrollWithCarets';
import { locationUrl } from 'src/services/route-utils';
import useCenteredCarousel from 'src/hooks/useCenteredCarousel';
import LocationCardPlaceholder from 'public/images/locations/location-card.svg';

type Props = {
    locations: any[];
};

export default function CityLocations({ locations }: Props) {
    const ulRef = createRef<HTMLUListElement>();
    useCenteredCarousel(ulRef);

    return (
        <ScrollWithCarets caretsClassName="top-1/4">
            <div className="container relative mx-auto h-[360px] overflow-visible">
                <ul ref={ulRef} className="md:pr-margin-semi-container absolute flex flex-nowrap gap-4 px-4 md:gap-8">
                    {locations.map((item) => (
                        <li data-carousel-item key={item.slug} className="group w-56 snap-center bg-white">
                            <div className="relative h-56">
                                <Link className="block h-full" href={locationUrl(item)}>
                                    {item.cover_image?.thumbnail ? (
                                        <Image
                                            className="object-cover"
                                            alt={item.name}
                                            src={item.cover_image.thumbnail}
                                            placeholder={item.cover_image.placeholder}
                                            fill
                                            quality={75}
                                            sizes="224"
                                        />
                                    ) : (
                                        <LocationCardPlaceholder />
                                    )}
                                </Link>
                            </div>
                            <div className="p-4">
                                <Link
                                    href={locationUrl(item)}
                                    className="decoration-1 underline-offset-4 group-hover:underline">
                                    <h3 className="mb-4 line-clamp-2 text-lg">{item.name}</h3>
                                </Link>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </ScrollWithCarets>
    );
}
